import { useEffect, useState } from "react";
import Landing from "./Landing";
import "../styles/Intro.css";

import img1 from "../assets/intro-images/image1.jpg";
import img2 from "../assets/intro-images/image2.jpg";
import img3 from "../assets/intro-images/image3.jpg";
import img4 from "../assets/intro-images/image4.jpg";
import img5 from "../assets/intro-images/image5.jpg";
import houseImg from "../assets/intro-images/image6.jpg";

/* image6 === the exact asset the landing hero background uses (see Landing.css) */
const IMAGES = [img1, img2, img3, img4, img5, houseImg];

const GEO = ["G", "e", "o"];
const STATE = ["s", "t", "a", "t", "e"];

/* Timeline: [ms, action]  —  total ~6.5s
   initial → word → split(+img0) → img1..img5 (400ms each) → expand → reveal → complete */
const STEPS = [
  [100, "word"],
  [1200, "split"],
  [1650, "img:1"],
  [2050, "img:2"],
  [2450, "img:3"],
  [2850, "img:4"],
  [3250, "img:5"],
  [3800, "expand"],
  [5400, "reveal"],
  [6500, "complete"],
];

const Intro = () => {
  const [phase, setPhase] = useState("initial");
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const steps = window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? [[300, "reveal"], [1000, "complete"]]
      : STEPS;
    const timers = steps.map(([delay, action]) =>
      setTimeout(() => {
        if (action.startsWith("img:")) setIdx(Number(action.slice(4)));
        else setPhase(action);
      }, delay)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  const holding = phase !== "reveal" && phase !== "complete";

  useEffect(() => {
    document.body.style.overflow = holding ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [holding]);

  return (
    <div className={`intro-shell ${holding ? "intro-hold" : "intro-reveal"}`}>
      <Landing />

      {phase !== "complete" && (
        <div className={`intro-overlay phase-${phase}`} aria-hidden="true">
          <div className="intro-word">
            <span className="intro-part">
              {GEO.map((c, i) => (
                <span className="intro-char-wrap" key={i}>
                  <span className="intro-char" style={{ "--ci": i }}>{c}</span>
                </span>
              ))}
            </span>

            <span className="intro-frame">
              {IMAGES.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  draggable="false"
                  className={i === idx ? "is-current" : ""}
                />
              ))}
            </span>

            <span className="intro-part">
              {STATE.map((c, i) => (
                <span className="intro-char-wrap" key={i}>
                  <span className="intro-char" style={{ "--ci": i + 3 }}>{c}</span>
                </span>
              ))}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Intro;
